// extracted by mini-css-extract-plugin
export var aboveInput = "_lc-0";
export var actionButton = "_lc-5";
export var actionButtonContainer = "_lc-1";
export var actionIcon = "_lc-6";
export var aiInfoContainer = "_lc-2";
export var attachmentWrapper = "_lc-7";
export var bold = "_lc-3";
export var checkIcon = "_lc-8";
export var clickingRecipientBar = "_lc-11";
export var commentThreadSwitch = "_lc-a";
export var draftImage = "_lc-b";
export var draftImageContainer = "_lc-c";
export var draftImages = "_lc-e";
export var editButton = "_lc-g";
export var editor = "_lc-f";
export var editorContainer = "_lc-y";
export var editorErrorTooltipWrapper = "_lc-9";
export var headerDivider = "_lc-h";
export var icon = "_lc-i";
export var info = "_lc-j";
export var internal = "_lc-n";
export var internalDivider = "_lc-k";
export var internalMessage = "_lc-l";
export var messageInputCard = "_lc-m";
export var messageInputForm = "_lc-o";
export var messageInputFormInternal = "_lc-p";
export var options = "_lc-q";
export var publicMessageCustomer = "_lc-s";
export var publicMessageMerchant = "_lc-r";
export var removeImageButton = "_lc-d";
export var replyButtons = "_lc-t";
export var showSignatureButton = "_lc-u";
export var spinner = "_lc-v";
export var verticalButtonDivider = "_lc-4";
export var visibilitySelector = "_lc-w";
export var warning = "_lc-x";
export var wrappingText = "_lc-z";
export var writingInternalNoteTopBorder = "_lc-10";